import React, { Children, Component } from 'react';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

//      
var Column = function (_Component) {
  inherits(Column, _Component);

  function Column() {
    classCallCheck(this, Column);
    return possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
  }

  createClass(Column, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return Column;
}(Component);

//      
var ColumnWrapper = function (_Component) {
  inherits(ColumnWrapper, _Component);

  function ColumnWrapper() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ColumnWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ColumnWrapper.__proto__ || Object.getPrototypeOf(ColumnWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      _grow: 1,
      _basis: 'auto'
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ColumnWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          grow = _props.grow,
          basis = _props.basis,
          rowData = _props.rowData,
          toggle = _props.toggle,
          rowMetadata = _props.rowMetadata,
          renderCell = _props.renderCell,
          className = _props.className;
      var _state = this.state,
          _grow = _state._grow,
          _basis = _state._basis;


      var flexGrow = grow != null ? grow : _grow;
      var flexBasis = basis != null ? basis : _basis;

      var baseClass = className ? 'cp_tree-table_column ' + className : 'cp_tree-table_column';
      return React.createElement(
        'div',
        { className: baseClass,
          style: _extends({}, STYLE_COLUMN, { flexGrow: flexGrow, flexBasis: flexBasis }) },
        renderCell(rowData, rowMetadata, toggle)
      );
    }
  }]);
  return ColumnWrapper;
}(Component);

var STYLE_COLUMN = {
  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'hidden'
};

//      
var VirtualListRow = function (_Component) {
  inherits(VirtualListRow, _Component);

  function VirtualListRow() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, VirtualListRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = VirtualListRow.__proto__ || Object.getPrototypeOf(VirtualListRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      overscanHeight: 100,
      height: 0,
      topOffset: 0
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(VirtualListRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          row = _props.row,
          hasVisibleChildren = _props.hasVisibleChildren,
          index = _props.index,
          onToggle = _props.onToggle,
          columns = _props.columns;


      var metadata = _extends({}, row.getMetadata(), { hasVisibleChildren: hasVisibleChildren });

      return React.createElement(
        'div',
        { className: 'cp_tree-table_row',
          style: _extends({}, STYLE_ROW, { height: row.getHeight() + 'px' }),
          'data-rindex': index,
          'data-depth': row.depth },
        Children.toArray(columns).map(function (column, index) {
          return React.createElement(ColumnWrapper, _extends({ key: index
          }, column.props, {

            rowData: row.data,
            toggle: onToggle,
            rowMetadata: metadata }));
        })
      );
    }
  }]);
  return VirtualListRow;
}(Component);

var STYLE_ROW = {
  display: 'flex',

  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'hidden',
  width: '100%'
};

//      
var Row = function () {
  // tree depth
  // row data


  function Row(data, hasChildren) {
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var isVisible = arguments[3];
    var height = arguments[4];
    classCallCheck(this, Row);
    this.parent = null;
    this._height = 26;
    this._cacheHeight = 26;

    this.data = data;
    this.depth = depth;
    this._hasChildren = hasChildren;

    if (height != null) {
      this._height = height;
      this._cacheHeight = height;
    }

    if (!isVisible) {
      this._height = 0;
    }
  } // height in px (26px - fallback value)


  createClass(Row, [{
    key: 'setHeight',
    value: function setHeight(value) {
      this._updateHeight(value);
      if (value > 0) {
        this._cacheHeight = value;
      }
    }
  }, {
    key: 'getHeight',
    value: function getHeight() {
      return this._height;
    }
  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this._height > 0;
    }
  }, {
    key: 'getMetadata',
    value: function getMetadata() {
      return {
        depth: this.depth,
        hasChildren: this._hasChildren
      };
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      if (this._height > 0) {
        this.hide();
      } else {
        this.show();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this._cacheHeight = this._height;
      this._updateHeight(0);
    }
  }, {
    key: 'show',
    value: function show() {
      this._updateHeight(this._cacheHeight);
    }
  }, {
    key: '_updateHeight',
    value: function _updateHeight(value) {
      var diff = value - this._height;
      if (diff) {
        for (var n = this; n; n = n.parent) {
          n._height += diff;
        }
      }
    }
  }]);
  return Row;
}();

//      
var findNodeData = function findNodeData(root, dataNode) {
  var result = void 0;

  root.mapAll(function (row) {
    if (dataNode.data === row.data) {
      result = row;
      return true;
    }
  });
  return result;
};

//      
var processData = function processData(data) {
  var rowHeightDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return processLevel(data, rowHeightDefault, 0, true);
};

var processLevel = function processLevel(data, rowHeightDefault) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var isVisible = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var result = [];
  for (var i = 0; i < data.length; i++) {
    var hasChildren = data[i].children != null && data[i].children.length > 0;

    result.push(new Row(data[i].data, hasChildren, depth, isVisible, data[i].height || rowHeightDefault));

    if (data[i].children && data[i].children.length > 0) {
      processLevel(data[i].children, rowHeightDefault, depth + 1).forEach(function (row) {
        result.push(row);
      });
    }
  }
  return result;
};

var indexOf = function indexOf(needle, haystack) {
  for (var i = 0; i < haystack.length; i++) {
    if (haystack[i] === needle) {
      return i;
    }
  }
  return -1;
};

var noop = function noop() {
  return undefined;
};

//      
var BTNode = function () {
  function BTNode(children) {
    classCallCheck(this, BTNode);
    this.parent = null;
    this.children = [];
    this._size = 0;
    this._height = 0;

    this.children = children;

    var size = 0,
        height = 0;
    for (var i = 0; i < children.length; ++i) {
      var ch = children[i];
      size += ch.getSize();
      height += ch.getHeight();
      ch.parent = this;
    }

    this._size = size;
    this._height = height;
  }

  createClass(BTNode, [{
    key: 'getSize',
    value: function getSize() {
      return this._size;
    }
  }, {
    key: 'getHeight',
    value: function getHeight() {
      return this._height;
    }

    // https://github.com/codemirror/CodeMirror/blob/e03ef21df390753eb35ff8426dd99b1be4d29d74/src/model/chunk.js#L79

  }, {
    key: 'removeInner',
    value: function removeInner(at, n) {
      this._size -= n;
      for (var i = 0; i < this.children.length; i++) {
        var child = this.children[i],
            sz = child.getSize();
        if (at < sz) {
          var rm = Math.min(n, sz - at),
              oldHeight = child.getHeight();
          child.removeInner(at, rm);
          this._height -= oldHeight - child.getHeight();
          if (sz === rm) {
            this.children.splice(i--, 1);
            child.parent = null;
          }
          n -= rm;
          if (n === 0) {
            break;
          }
          at = 0;
        } else {
          at -= sz;
        }
      }
      // If the result is smaller than 25 rows, ensure that it is a
      // single leaf node.
      if (this.getSize() - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof BTLeaf))) {
        var rows = [];
        this.collapse(rows);
        this.children = [new BTLeaf(rows)];
        this.children[0].parent = this;
      }
    }
  }, {
    key: 'collapse',
    value: function collapse(rows) {
      for (var i = 0; i < this.children.length; i++) {
        this.children[i].collapse(rows);
      }
    }

    // https://github.com/codemirror/CodeMirror/blob/e03ef21df390753eb35ff8426dd99b1be4d29d74/src/model/chunk.js#L107

  }, {
    key: 'insertInner',
    value: function insertInner(at, rows, height) {
      this._size += rows.length;
      this._height += height;

      for (var i = 0; i < this.children.length; i++) {
        var child = this.children[i],
            sz = child.getSize();
        if (at <= sz) {
          child.insertInner(at, rows, height);
          if (child instanceof BTLeaf && child.getSize() > 50) {
            // To avoid memory thrashing when child.rows is huge (e.g. first view of a large file), it's never spliced.
            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
            var remaining = child.getSize() % 25 + 25;
            for (var pos = remaining; pos < child.getSize();) {
              var leaf = new BTLeaf(child.rows.slice(pos, pos += 25));
              child._height -= leaf.getHeight();
              this.children.splice(++i, 0, leaf);
              leaf.parent = this;
            }
            child.rows = child.rows.slice(0, remaining);
            this.maybeSpill();
          }
          break;
        }
        at -= sz;
      }
    }

    // When a node has grown, check whether it should be split.

  }, {
    key: 'maybeSpill',
    value: function maybeSpill() {
      if (this.children.length <= 10) {
        return;
      }
      var me = this;
      do {
        var spilled = me.children.splice(me.children.length - 5, 5);
        var sibling = new BTNode(spilled);
        if (!me.parent) {
          // Become the parent node
          var copy = new BTNode(me.children);
          copy.parent = me;
          me.children = [copy, sibling];
          me = copy;
        } else {
          me._size -= sibling.getSize();
          me._height -= sibling.getHeight();

          var parent = me.parent;
          if (parent && parent.children) {
            var myIndex = indexOf(me, parent.children);
            parent.children.splice(myIndex + 1, 0, sibling);
          }
        }
        sibling.parent = me.parent;
      } while (me.children.length > 10);
      if (me.parent) {
        me.parent.maybeSpill();
      }
    }
  }, {
    key: 'mapRange',
    value: function mapRange(at, n, op) {
      for (var i = 0; i < this.children.length; i++) {
        var child = this.children[i],
            sz = child.getSize();
        if (at < sz) {
          var used = Math.min(n, sz - at);
          if (child.mapRange(at, used, op)) {
            return true;
          }
          n -= used;
          if (n === 0) {
            break;
          }
          at = 0;
        } else {
          at -= sz;
        }
      }
    }
  }, {
    key: 'mapAll',
    value: function mapAll(op) {
      return this.mapRange(0, this._size, op);
    }
  }]);
  return BTNode;
}();

//      
var BTLeaf = function () {
  function BTLeaf() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    classCallCheck(this, BTLeaf);
    this.parent = null;
    this.rows = [];
    this._height = 0;

    this.rows = rows;

    var height = 0;
    for (var i = 0; i < rows.length; ++i) {
      rows[i].parent = this;
      height += rows[i].getHeight();
    }
    this._height = height;
  }

  createClass(BTLeaf, [{
    key: 'getSize',
    value: function getSize() {
      return this.rows.length;
    }
  }, {
    key: 'getHeight',
    value: function getHeight() {
      return this._height;
    }

    // Remove n rows at offset 'at'.

  }, {
    key: 'removeInner',
    value: function removeInner(at, n) {
      for (var i = at, e = at + n; i < e; ++i) {
        var row = this.rows[i];
        this._height -= row.getHeight();

        row.parent = null;
      }
      this.rows.splice(at, n);
    }
  }, {
    key: 'collapse',
    value: function collapse(rows) {
      rows.push.apply(rows, this.rows);
    }

    // Insert the given array of rows at offset 'at', count them as
    // having the given height.

  }, {
    key: 'insertInner',
    value: function insertInner(at, rows, height) {
      this._height += height;
      this.rows = this.rows.slice(0, at).concat(rows).concat(this.rows.slice(at));
      for (var i = 0; i < rows.length; ++i) {
        rows[i].parent = this;
      }
    }
  }, {
    key: 'mapRange',
    value: function mapRange(at, n, op) {
      for (var e = at + n; at < e; ++at) {
        if (op(this.rows[at])) {
          return true;
        }
      }
    }
  }]);
  return BTLeaf;
}();

//      
var BTRoot = function (_BTNode) {
  inherits(BTRoot, _BTNode);

  function BTRoot() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    classCallCheck(this, BTRoot);

    var _this = possibleConstructorReturn(this, (BTRoot.__proto__ || Object.getPrototypeOf(BTRoot)).call(this, [new BTLeaf([])]));

    _this.insert(0, data);
    return _this;
  }

  createClass(BTRoot, [{
    key: 'insert',
    value: function insert(at, rows) {
      var height = 0;
      for (var i = 0; i < rows.length; ++i) {
        height += rows[i].getHeight();
      }
      get(BTRoot.prototype.__proto__ || Object.getPrototypeOf(BTRoot.prototype), 'insertInner', this).call(this, at, rows, height);
    }
  }, {
    key: 'remove',
    value: function remove(at, n) {
      get(BTRoot.prototype.__proto__ || Object.getPrototypeOf(BTRoot.prototype), 'removeInner', this).call(this, at, n);
    }
  }, {
    key: 'getRow',
    value: function getRow(index) {
      if (index < 0 || index >= this.getSize()) {
        throw new Error('Invalid index! No row at index: ' + index);
      }
      var node = this;
      while (node instanceof BTNode) {
        for (var i = 0;; i++) {
          var child = node.children[i],
              sz = child.getSize();
          if (index < sz) {
            node = child;
            break;
          }
          index -= sz;
        }
      }
      return node.rows[index];
    }
  }, {
    key: 'getRowIndex',
    value: function getRowIndex(row) {
      if (row.parent == null) {
        throw new Error('Invalid row object! No parent node: (row.parent == null)');
      }
      var cur = row.parent,
          index = indexOf(row, cur.rows);
      for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
        for (var i = 0;; i++) {
          if (chunk.children[i] === cur) {
            break;
          }
          index += chunk.children[i].getSize();
        }
      }
      return index;
    }
  }, {
    key: 'getIndexAtY',
    value: function getIndexAtY(y) {
      if (y < 0 || y > this.getHeight()) {
        throw new Error('Invalid y position! No row at y: ' + y);
      }

      var n = 0,
          height = y;
      var node = this;
      do {
        var ch = 0;
        for (var _i = 0; _i < node.children.length; _i++) {
          var child = node.children[_i];
          ch = child.getHeight();
          if (height < ch) {
            node = child;
            break;
          }
          height -= ch;
          n += child.getSize();
        }
        if (height >= ch) {
          return n;
        }
      } while (!node.rows);

      var i = 0;
      if (node instanceof BTLeaf) {
        for (; i < node.getSize(); i++) {
          var row = node.rows[i],
              rHeight = row.getHeight();
          if (height < rHeight) {
            break;
          }
          height -= rHeight;
        }
      }
      return n + i;
    }
  }, {
    key: 'getYAtIndex',
    value: function getYAtIndex(index) {
      var row = this.getRow(index);
      if (row.parent == null) {
        throw new Error('Invalid row object! No parent node: (row.parent == null)');
      }

      var height = 0,
          chunk = row.parent;
      for (var i = 0; i < chunk.rows.length; i++) {
        var rowObj = chunk.rows[i];
        if (rowObj === row) {
          break;
        } else {
          height += rowObj.getHeight();
        }
      }
      for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
        for (var _i2 = 0; _i2 < p.children.length; _i2++) {
          var cur = p.children[_i2];
          if (cur === chunk) {
            break;
          } else {
            height += cur.getHeight();
          }
        }
      }
      return height;
    }
  }]);
  return BTRoot;
}(BTNode);

//      
var VirtualList = function (_Component) {
  inherits(VirtualList, _Component);

  function VirtualList() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, VirtualList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = VirtualList.__proto__ || Object.getPrototypeOf(VirtualList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      overscanHeight: 100,
      height: 0,
      topOffset: 0
    }, _this._handleScroll = function () {
      var onScroll = _this.props.onScroll;


      if (_this.container) {
        var scrollTop = _this.container.scrollTop;


        onScroll(scrollTop);

        _this.setState({
          topOffset: scrollTop
        });
      }
    }, _this._setHeight = function () {
      var height = _this.state.height;


      if (_this.container) {
        var offsetHeight = _this.container.offsetHeight;


        if (height !== offsetHeight) {
          _this.setState({
            height: offsetHeight
          });
        }
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(VirtualList, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._setHeight();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setHeight();
      window.addEventListener("resize", this._setHeight);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this._setHeight);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          root = _props.root,
          columns = _props.columns,
          _onToggle = _props.onToggle,
          className = _props.className;
      var _state = this.state,
          overscanHeight = _state.overscanHeight,
          height = _state.height,
          topOffset = _state.topOffset;


      var startYMax = Math.max(0, root.getHeight() - height - overscanHeight * 2);
      var startY = Math.min(startYMax, Math.max(0, topOffset - overscanHeight));
      var startIndex = root.getIndexAtY(startY);

      var endY = Math.min(root.getHeight(), topOffset + height + overscanHeight);
      var endIndex = root.getIndexAtY(endY);

      var contentTopOffset = root.getYAtIndex(startIndex);

      var visibleRowsData = [],
          lastVisibleRowIndex = void 0;
      root.mapRange(startIndex, endIndex - startIndex, function (row) {
        if (row.isVisible()) {
          if (lastVisibleRowIndex != null && !visibleRowsData[lastVisibleRowIndex].hasVisibleChildren) {
            var data = visibleRowsData[lastVisibleRowIndex];

            if (data != null && data.row.depth === row.depth - 1 && !data.hasVisibleChildren) {
              visibleRowsData[lastVisibleRowIndex].hasVisibleChildren = true;
            }
          }

          lastVisibleRowIndex = visibleRowsData.length;
          visibleRowsData.push({
            row: row,
            hasVisibleChildren: false
          });
        }
      });

      var visibleRows = [],
          relativeIndex = 0;
      visibleRowsData.forEach(function (data) {
        visibleRows.push(React.createElement(VirtualListRow, {
          row: data.row,
          columns: columns,
          hasVisibleChildren: data.hasVisibleChildren,
          index: relativeIndex,
          key: relativeIndex++,
          onToggle: function onToggle() {
            return _onToggle(data.row);
          } }));
      });

      return React.createElement(
        'div',
        { className: className,
          style: _extends({}, STYLE_LIST, { height: this.props.height + 'px' }),
          ref: function ref(elem) {
            _this2.container = elem;
          },
          onScroll: this._handleScroll },
        React.createElement(
          'div',
          { style: _extends({}, STYLE_WRAPPER, { height: root.getHeight() + 'px' }) },
          React.createElement(
            'div',
            { style: _extends({}, STYLE_CONTENT, { top: contentTopOffset + 'px' }),
              className: 'cp_tree-table_mover' },
            visibleRows
          )
        )
      );
    }
  }, {
    key: 'scrollTop',
    value: function scrollTop() {
      var posY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.container) {
        this.container.scrollTop = posY;
      }
    }

    // virtual scroll


    // virtual scroll

  }]);
  return VirtualList;
}(Component);

var STYLE_LIST = {
  overflow: 'auto',
  WebkitOverflowScrolling: 'touch'
};

var STYLE_WRAPPER = {
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  minHeight: '100%'
};

var STYLE_CONTENT = {
  position: 'absolute',
  overflow: 'visible',
  height: '100%',
  width: '100%',
  top: '0',
  left: '0'
};

//      
var TreeDataTable = function (_Component) {
  inherits(TreeDataTable, _Component);

  function TreeDataTable(props) {
    classCallCheck(this, TreeDataTable);

    var _this = possibleConstructorReturn(this, (TreeDataTable.__proto__ || Object.getPrototypeOf(TreeDataTable)).call(this, props));

    _this._handleOnToggle = function (row) {
      var root = _this.state.root;


      var delta = _this._toggleRow(root, row);
      if (delta.hasChange) {
        _this.setState({ root: delta.root });
      }
    };

    _this._toggleRow = function (root, row) {
      var currentDepth = row.depth;
      var rowIndex = Math.min(root.getRowIndex(row) + 1, root.getSize());

      var hasChange = false;
      var toggleOpen = void 0;
      root.mapRange(rowIndex, root.getSize() - rowIndex, function (row) {
        if (toggleOpen == null) {
          toggleOpen = !row.isVisible();
        }

        if (row.depth >= currentDepth + 1) {
          if (row.depth === currentDepth + 1) {
            row.toggle();
            hasChange = true;
          } else if (!toggleOpen && row.isVisible()) {
            // Close all children
            row.toggle();
            hasChange = true;
          }

          return false;
        } else {
          return true;
        }
      });

      return {
        root: root,
        hasChange: hasChange
      };
    };

    var rowHeight = props.rowHeight;


    _this.state = {
      root: new BTRoot(processData(_this.props.data, rowHeight))
    };
    return _this;
  }

  createClass(TreeDataTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          height = _props.height,
          children = _props.children,
          onScroll = _props.onScroll,
          className = _props.className;


      var baseClass = className ? 'cp_tree-table ' + className : 'cp_tree-table';
      return React.createElement(VirtualList, { className: baseClass,
        ref: function ref(elem) {
          _this2.virtualList = elem;
        },

        columns: children,

        height: height || 200,
        root: this.state.root,

        onScroll: onScroll || noop,
        onToggle: function onToggle(row) {
          return _this2._handleOnToggle(row);
        } });
    }

    // Public API

  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(node) {
      var _this3 = this;

      var expandAncestors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var root = this.state.root;


      var row = findNodeData(root, node);
      if (row) {
        var rowIndex = root.getRowIndex(row);
        if (expandAncestors && !row.isVisible()) {
          var ancestors = [];
          for (var currentRowIndex = Math.max(rowIndex - 1, 0), previousDepth = row.depth; currentRowIndex >= 0; currentRowIndex--) {
            var currentRow = root.getRow(currentRowIndex);

            if (currentRow.depth === previousDepth - 1) {
              // Parent
              ancestors.push(currentRow);
              previousDepth = currentRow.depth;

              if (currentRow.isVisible()) {
                // From here up, all the ancestors are visible
                break;
              }
            }

            if (currentRow.depth === 0) {
              break;
            }
          }

          // Batch changes
          var currentRoot = root;
          var hasChange = false;
          for (var i = 0; i < ancestors.length; i++) {
            var _currentRow = ancestors[i];
            var delta = this._toggleRow(currentRoot, _currentRow);

            if (!hasChange) {
              hasChange = delta.hasChange;
            }
          }

          if (hasChange) {
            this.setState({ root: currentRoot }, function () {
              var posY = root.getYAtIndex(rowIndex);
              _this3.scrollTo(posY);
            });
          }
        } else {
          var posY = root.getYAtIndex(rowIndex);
          this.scrollTo(posY);
        }
      }
    }

    // Public API

  }, {
    key: 'scrollTo',
    value: function scrollTo(posY) {
      if (this.virtualList) {
        this.virtualList.scrollTop(posY);
      }
    }

    // Makes rows in the given range that don't represent root nodes (row.depth == 0) visible

  }, {
    key: '_showRowsInRange',
    value: function _showRowsInRange(from, to) {
      var root = this.state.root;


      var _from = from != null ? from : 0;
      var _to = to != null ? to : root.getSize();

      // Validation
      if (!this._isOpRangeValid(_from, _to)) {
        return;
      }

      // Expand op
      var hasChange = false;
      root.mapRange(_from, _to, function (row) {
        if (row.depth > 0 && !row.isVisible()) {
          row.show();
          hasChange = true;
        }
      });

      if (hasChange) {
        this.setState({ root: root });
      }
    }

    // Public API

  }, {
    key: 'expandAll',
    value: function expandAll() {
      // _showRowsInRange alias with the default arguments
      this._showRowsInRange();
    }

    // Hides rows in the given range that don't represent root nodes (row.depth == 0)

  }, {
    key: '_hideRowsInRange',
    value: function _hideRowsInRange(from, to) {
      var root = this.state.root;


      var _from = from != null ? from : 0;
      var _to = to != null ? to : root.getSize();

      // Validation
      if (!this._isOpRangeValid(_from, _to)) {
        return;
      }

      // Expand op
      var hasChange = false;
      root.mapRange(_from, _to, function (row) {
        if (row.depth > 0 && row.isVisible()) {
          row.hide();
          hasChange = true;
        }
      });

      if (hasChange) {
        this.setState({ root: root });
      }
    }

    // Public API

  }, {
    key: 'collapseAll',
    value: function collapseAll() {
      // _hideRowsInRange alias with the default arguments
      this._hideRowsInRange();
    }
  }, {
    key: '_isOpRangeValid',
    value: function _isOpRangeValid(from, to) {
      var root = this.state.root;

      var maxTo = root.getSize();
      // Validation
      if (from < 0) {
        console.warn('Invalid range: from < 0');
        return false;
      }
      if (from > maxTo) {
        console.warn('Invalid range: from > max size');
        return false;
      }
      if (to > maxTo) {
        console.warn('Invalid range: to > max size');
        return false;
      }
      if (from > to) {
        console.warn('Invalid range: to > from');
        return false;
      }
      return true;
    }
  }]);
  return TreeDataTable;
}(Component);

TreeDataTable.Column = Column;

export default TreeDataTable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/cp-react-tree-table/dist/index.es.js
// module id = 119
// module chunks = 0